"use client";

import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RelaxInMurrieta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/disneyland_resort_california_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/knotts_berry_farm_attractions_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/anaheim_convention_center_view_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/little_saigon_cultural_arch_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/john_wayne_airport_sna_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/long_beach_airport_lgb_wallpaper.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596668/img/lax_international_airport_wallpaper.png"];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);
  return <section id="relax-in-murrieta" className="relative w-full h-[100svh] min-h-[600px] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0" aria-hidden="true">
        {images.map((src, i) => <img key={src} data-index={i} src={src} alt="" className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${i === currentImageIndex ? "opacity-100" : "opacity-0"}`} />)}
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-black/20" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 w-full max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium text-white tracking-tight leading-[1.15] drop-shadow-md max-w-4xl">Your cozy home base in the heart of Orange County!</h1>

        <p className="mt-6 text-lg sm:text-xl text-white/90 max-w-3xl mx-auto drop-shadow-sm font-sans leading-relaxed">Just minutes from Disneyland, Knott’s Berry Farm, Anaheim Convention Center, and Little Saigon, our comfortable rooms put you steps from world-class beaches like Huntington and Long Beach, incredible global dining, and easy access to John Wayne, Long Beach, and LAX airports.
<div>Whether you’re here for thrills, business, or pure relaxation, book now and make unforgettable memories in sunny SoCal!</div></p>

        

        <div className="mt-10 sm:mt-12">
          <Link to="https://www.airbnb.com/rooms/1516286561442761715" newTab>
            <Button size="lg" className="rounded-full px-12 py-8 sm:px-16 sm:py-10 text-xl sm:text-2xl font-semibold shadow-xl animate-pulse hover:animate-none transition-transform hover:scale-105">
              Book on Airbnb
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center animate-bounce text-white/90 hover:text-white transition-colors">
        <span className="sr-only">Scroll down</span>
        <ChevronDown className="size-8 sm:size-10 stroke-[1.5] drop-shadow-sm" />
      </div>
    </section>;
}